Bingo.LocalStorage = {};

Bingo.LocalStorage.get = (key, defaultValue) => {
    const result = window.localStorage.getItem(key);
    if ((result === null || result === undefined) && defaultValue !== undefined) {
        return defaultValue;
    }
    return result;
};

Bingo.LocalStorage.set = (key, value) => {
    window.localStorage.setItem(key, value);
};
